import { Component } from "@angular/core";
import { CommonService } from "./shared/service/common.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "Swayam";
  constructor(public common: CommonService) {
    /*  setTimeout(() => {
      this.common.loader = false;
    }, 2000); */
  }
}
